import { OptimizelyDecision } from '@optimizely/optimizely-sdk'

// single source of truth for known feature flags & experiments
// Union of feature flags from classy-embedded-app and classy-checkout
export const OPTIMIZELY_FEATURE_FLAGS = {
  classy_mparticle: 'classy_mparticle',
  npo_checkout_app_2025: 'npo_checkout_app_2025',
  npo_checkout_app_2025_aa: 'npo_checkout_app_2025_aa',
  npo_checkout_single_column_layout: 'npo_checkout_single_column_layout',
  npo_campaign_page_floating_donate_button: 'npo_campaign_page_floating_donate_button',
} as const

// * Test exposures that can happen in Whammy
export const OPTIMIZELY_EXPOSURE_FLAGS: readonly string[] = [
  OPTIMIZELY_FEATURE_FLAGS.npo_campaign_page_floating_donate_button,
]

export type OptimizelyFeatureFlags =
  (typeof OPTIMIZELY_FEATURE_FLAGS)[keyof typeof OPTIMIZELY_FEATURE_FLAGS]

// userContext is not serializable, so we need to omit it
export type OptimizelyDecisionWithoutUserContext = Omit<OptimizelyDecision, 'userContext'>

export type OptimizelyContextType = Record<
  OptimizelyFeatureFlags,
  OptimizelyDecisionWithoutUserContext
>

// Initialize with all feature flags set to false
export const defaultOptimizelyContext: OptimizelyContextType = Object.values(
  OPTIMIZELY_FEATURE_FLAGS,
).reduce(
  (acc, flag) => ({
    ...acc,
    [flag]: {
      enabled: false,
      variationKey: null,
      variables: {},
      ruleKey: null,
      flagKey: flag,
      reasons: [],
    },
  }),
  {} as Record<OptimizelyFeatureFlags, OptimizelyDecisionWithoutUserContext>,
)

// URL parameter override type
export type UrlOverrideMap = Record<string, OptimizelyDecisionWithoutUserContext>
